import { getBuildTag } from '../constant/get-build-tag.enum'
import { OS_TYPES } from '../constant/os-types.enum'
import { CPU_ARCHITECTURE_TYPES } from '../constant/cpu-architecture-types.enum'
import { v4 as uuidv4 } from 'uuid'
import { httpHook as httpHookInstance } from './http-hook'
import { ITC as _itc } from './itc'
import { TestHelper as _TestHelper } from './test_helper'
import _ipc from './ipc'
import InfaceEnv from '../env'

const path = typeof window !== 'undefined' ? {} : require("path")
const readdirp = typeof window !== 'undefined' ? {} : require('readdirp')


if (typeof window !== 'undefined') {
  if (!window.inface) {
    window.inface = {}
  }
  window.inface.itc = _itc
}

export const iconv = require('iconv-lite')
export const urlencode = require('urlencode')

/**
 * 번들링된 SDK 모듈내부에서 새로운 모듈을 적재시 Webpack에서 적재하는 것이 아닌 Native 모듈을 적재할때에 사용합니다
 */
export const requireNative = typeof __webpack_require__ === "function" ? __non_webpack_require__ : require

/**
 * SDK 모듈을 IMPORT합니다, PATH 정보가 우선시 되며, OS와 ARCHITECTURE 정보가 있을시
 * 그에 적합한 모듈을 적재합니다.
 * @example
 * loadModule("dist/my_sdk/sdk.node")
 * @example
 * loadModule(null, OS_TYPE.WINDOWS, CPU_ARCHITECTURE_TYPES.X86_64, "my_sdk", "sdk.node")
 * @param {String} [modulePath] - 모듈의 주소를 입력합니다
 * @param {OS_TYPES} os OS 정보를 입력합니다
 * @param {String} projectName 프로젝트 이름을 작성합니다 (공백 불허)
 * @param {String} targetModuleName Node.js 모듈의 파일 이름을 작성합니다
 * @param {CPU_ARCHITECTURE_TYPES} architecture CPU Architecture의 정보를 입력합니다.
 * @returns COMMON_JS_MODULE
 */
export function loadModulePath(
  modulePath,
  osType,
  cpuArchitectureType,
  projectName,
  targetModuleName
) {
    if (typeof window === 'undefined') {
        const fs = require('fs')
        
        const currentPath = process.cwd()
        const thirdLibsRootPath = !!InfaceEnv.value['3rdLibsRootDir'] ? InfaceEnv.value['3rdLibsRootDir'] : currentPath
        const NXI_DIRS = !!InfaceEnv.value['NXI_DIRS'] ? InfaceEnv.value['NXI_DIRS'] : [currentPath]
        const files = fs.readdirSync(process.cwd(), { withFileTypes: true } )
        const unityDataDirectories = files.filter(file => file.isDirectory()).filter(file => /[\w](_Data)$/.test(file.name))
        const unityGameDataPathDirent = unityDataDirectories[0] || { name: 'unknown'}
        const triesModulePath = [
            `${path.join(thirdLibsRootPath, targetModuleName)}`,
            ...NXI_DIRS.map(nxiPath => `${path.join(nxiPath, targetModuleName)}`),
            `${path.join(currentPath, targetModuleName)}`,
            `${path.join(currentPath, unityGameDataPathDirent.name, 'Plugins', targetModuleName)}`, // Unity Game
            `${path.join(currentPath, unityGameDataPathDirent.name, 'Plugins', 'x86_64', targetModuleName)}`, // Unity Game
            `${path.join(currentPath, 'Assets', 'Toy', 'Plugins', 'x86_64', targetModuleName)}`, // Unity Editor with 
            `${path.join(currentPath, "dist", getBuildTag(osType, cpuArchitectureType), projectName, targetModuleName)}`,
            `${path.join(currentPath, "dist", projectName, targetModuleName)}`,
            `${path.join(currentPath, "..", "..", "dist", "native", "win_x86_64")}`,
            `${path.join(currentPath, projectName, targetModuleName)}`,
            
            // `${path.join(
            //   __dirname,
            //   "dist",
            //   "x86_64-pc-windows-msvc",
            //   "platform-sdk",
            //   "nmcogame64.nxi.dll"
            // )}`,
            // `${path.join(
            //   __dirname,
            //   "..",
            //   "..",
            //   "..",
            //   "dist",
            //   "x86_64-pc-windows-msvc",
            //   "platform-sdk",
            //   "nmcogame64.nxi.dll"
            // )}`
          ]
        
          const existsFilePath = triesModulePath.map(path => {
            return { isExists: fs.existsSync(path), path }
          }).filter(v => v.isExists)[0]
          if (existsFilePath) {
            return existsFilePath.path
          }
    }
    
    return ''
}

export const loadModulePath_x86_64 = (projectName, moduleFileName) => {
  return loadModulePath(null, OS_TYPES.WINDOWS, CPU_ARCHITECTURE_TYPES.X86_64, projectName, moduleFileName)
}

export const loadModulePath_i686 = (projectName, moduleFileName) => {
  return loadModulePath(null, OS_TYPES.WINDOWS, CPU_ARCHITECTURE_TYPES.I686, projectName, moduleFileName)
}

export const loadModulePathEX = (projectName, moduleFileName) => {
  return new Promise((resolve) => {
    const filePath = loadModulePath_x86_64(projectName, moduleFileName)
    if (filePath) {
      return resolve(filePath)
    }
    const nxidirs = []
    readdirp(process.cwd(), {
      fileFilter: moduleFileName,
      alwaysStat: true,
      directoryFilter: ['!.git', '!*modules'],
    }).on('data', (entry) => {
      if (entry) {
        const fullPath = entry.fullPath
        const filename = entry.basename
        if (fullPath && filename) {
          const dllRootPath = fullPath.replace(new RegExp(`(${filename})$`), '')
          nxidirs.push(dllRootPath)
        }
      }
    }).on('end', () => {
      return resolve(path.join(`${nxidirs[0]}`, moduleFileName))
    })
  })
}

export const generateUUID = () => {
  return uuidv4()
}

export const httpHook = httpHookInstance

export const ITC = _itc

export const TestHelper = _TestHelper

export const IPC = _ipc

export default {
  iconv,
  urlencode,
  loadModulePath,
  loadModulePath_x86_64,
  loadModulePath_i686,
  loadModulePathEX,
  requireNative,
  generateUUID,
  httpHook,
  ITC,
  TestHelper,
  IPC
}
